import React, { useState, useRef, useEffect } from 'react';
import { Play, Pause } from 'lucide-react';

const AboutVideoBanner = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [showControls, setShowControls] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch(console.error);
    }
  }, []);

  const togglePlay = () => {
    const video = videoRef.current;
    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoClick = () => {
    togglePlay();
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  return (
    <section className="w-full py-20 sm:py-[120px] px-5 max-w-[1320px] mx-auto">
      <h3 className="libre-baskerville font-normal text-[32px] sm:text-[60px] lg:text-[86px] leading-[40px] sm:leading-[70px] lg:leading-[130px] text-center text-[#1D1D1F] mb-10 sm:my-10">
        About Us
      </h3>

      <div
        className="relative w-full md:h-[700px] overflow-hidden cursor-pointer group"
        onMouseEnter={() => setShowControls(true)}
        onMouseLeave={() => setShowControls(false)}
        onClick={handleVideoClick}
      >
        <video
          ref={videoRef}
          className="w-full h-full object-cover rounded-[10px]"
          autoPlay
          muted
          loop
          playsInline
          onPlay={handleVideoPlay}
          onPause={handleVideoPause}
        >
          <source src="/assets/about-video-banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div
          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
            showControls || !isPlaying ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="bg-black/30 backdrop-blur-sm rounded-full p-6 hover:bg-black/50 transition-all duration-200 hover:scale-110">
            {isPlaying ? (
              <Pause className="w-12 h-12 text-white fill-white" />
            ) : (
              <Play className="w-12 h-12 text-white fill-white ml-1" />
            )}
          </div>
        </div>

        <div
          className={`absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-black/20 transition-opacity duration-300 ${
            showControls || !isPlaying ? 'opacity-100' : 'opacity-0'
          }`}
        />
      </div>
    </section>
  );
};

export default AboutVideoBanner;
